import type { Ref } from "vue";

import type { UseStorageOptions } from "@vueuse/core";
import { useLocalStorage } from "@vueuse/core";

export const DsLocalData = <T>(
  key: string,
  initialValue: T,
  options?: UseStorageOptions<T>
): Ref<T> => {
  const prefixedKey = `${import.meta.env.VITE_APP_LOCAL_STORAGE_PREFIX}.${key}`;
  return useLocalStorage(prefixedKey, initialValue, options);
};

export const DsClearLocalData = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(import.meta.env.VITE_APP_LOCAL_STORAGE_PREFIX)) {
      localStorage.removeItem(key);
    }
  });
};
